import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import Loader from "react-js-loader";
import Skeleton from "react-loading-skeleton";
import { Form } from "react-bootstrap";
import SubmitButton from "../Common/buttons/SubmitButton";
import { ShoppingService } from "../../services/shopping/shopping";
import { setForUser, setForUserAddress } from "../../store/reducers/replica";

const ProductLists = ({
  products,
  isLoading,
  activeTab,
  searchInputs,
  setSearchInputs,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const activeShoppingTab = useSelector(
    (state) => state?.shopping?.shoppingTab
  );
  const [cartId, setCartId] = useState("");
  const [userId, setUserId] = useState("");
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const addCartMutation = ApiHook.CallAddToCart(activeTab);
  const checkUsername = ShoppingService.useCheckUsername(activeTab);
  const { data: cartItems } = ApiHook.CallCartItems();
  // useEffect(() => {
  //   localStorage.removeItem("forUser");
  // }, []);

  const productLoader = (
    <>
      {/* Loader */}
      {[...Array(3)].map((_, index) => (
        <div key={index} className="col-xl-3 col-lg-4 col-md-4">
          <div className="product_box">
            <div className="product_box_image">
              <Skeleton height="100%" />
            </div>
            <div className="product_box_content">
              <div className="product_box_head">
                <Skeleton width="40%" />
              </div>
              <div className="product_box_category">
                <Skeleton width="60%" />
              </div>
              <div className="product_box_amnt">
                <Skeleton width="20%" />
              </div>
            </div>
            <div className="product_box_btn_sec">
              <button className="product_box_btn1" disabled>
                <i className="fa fa-cart-shopping"></i> {t("add_to_cart")}
              </button>
              <a className="product_box_btn2">
                <i className="fa fa-eye"></i> {t("more_details")}
              </a>
            </div>
          </div>
        </div>
      ))}
    </>
  );
  const handleAddToCart = (id) => {
    const data = {
      packageId: id,
    };
    setCartId(id);
    addCartMutation.mutate(data, {
      onSuccess: (res) => {
        if (res?.status) {
          queryClient.invalidateQueries({ queryKey: ["cart-items"] });
        } else {
          if (res?.data?.code) {
            toast.error(res?.data?.description);
          } else {
            toast.error(res?.message);
          }
        }
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchInputs.username?.trim()) {
      return toast.error("Please enter a username");
    }
    const data = {
      username: searchInputs.username.trim(),
    };
    checkUsername.mutate(data, {
      onSuccess: (res) => {
        if (res.error) {
          setSearchInputs({
            username: "",
            fullname: "",
            address: "",
            forUserId: "",
          });
          return toast.error(res.error);
        }
        setSearchInputs((prevData) => ({
          ...prevData,
          fullname: res.fullName,
          forUserId: res.userId,
        }));
        localStorage.setItem(
          "forUser",
          JSON.stringify({
            id: res.userId,
            address: parseInt(searchInputs.address),
          })
        );
        setUserId(res.userId);
        dispatch(
          setForUserAddress({
            id: res.userId,
            address: parseInt(searchInputs.address),
          })
        );
        dispatch(
          setForUser({
            username: searchInputs.username,
            fullname: res.fullName,
          })
        );
      },
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setSearchInputs((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    if (id === "address") {
      localStorage.setItem(
        "forUser",
        JSON.stringify({
          id: userId,
          address: parseInt(value),
        })
      );
      dispatch(
        setForUserAddress({
          id: userId,
          address: parseInt(value),
        })
      );
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSearchInputs({
      username: "",
      fullname: "",
      address: "",
      forUserId: "",
    });
  };

  return (
    <div className="shoping_page_section">
      {/* {activeTab === "repurchase" && ( */}
      <Form className="d-flex gap-2" style={{flexWrap: 'wrap'}}>
        <Form.Group className="mb-3">
          <Form.Label>User name</Form.Label>
          <Form.Control
            id="username"
            type="text"
            placeholder={`User ID`}
            onChange={(e) => handleChange(e)}
            value={searchInputs.username}
            required
            // isInvalid={errorMessage?.username !== null}
          />
          <Form.Control.Feedback type="invalid">
            errorMessage.username
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            id="fullname"
            type="text"
            placeholder={`Full Name`}
            disabled="true"
            onChange={(e) => handleChange(e)}
            value={searchInputs.fullname}
            required
            // isInvalid={errorMessage?.username !== null}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Shipment To</Form.Label>
          <Form.Select
            disabled={searchInputs.username ? false : true}
            id="address"
            onChange={(e) => handleChange(e)}
            value={searchInputs.address}
            aria-label="Default select example"
          >
            <option>Select Address</option>
            <option value="1">BDA Address</option>
            <option value="2">User Address</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3" style={{ marginTop: "32px" }}>
          <button
            // isSubmitting={
            //     !isFormValid() || requestMutation.isLoading
            // }
            onClick={handleSubmit}
            className={"btn btn-primary"}
            // isLoading={requestMutation.isLoading}
          >
            Search
          </button>
        </Form.Group>
        <Form.Group className="mb-3" style={{ marginTop: "32px" }}>
          <button className="btn btn-secondary" onClick={handleReset}>
            {t("reset")}
          </button>
        </Form.Group>
      </Form>
      {/* )} */}
      <div className="row">
        {isLoading ? (
          // loader
          productLoader
        ) : products?.length ? (
          products?.map((product, index) => (
            <div className="col-xl-3 col-lg-4 col-md-4" key={index}>
              <div className="product_box">
                {activeShoppingTab === "rbvPack" ? (
                  ""
                ) : (
                  <div
                    // className={
                    //   (!activeShoppingTab === "rbvPack")
                    //     ?  (!cartItems?.length ||
                    //       !cartItems.find((_) => _.packageId === product.id))
                    //     ? "product-disabled-card" : ''
                    //     : ""
                    // }
                    className={
                      !cartItems?.length > 0 ||
                      !!cartItems?.find((_) => _.packageId === product.id)
                        ? ""
                        : "product-disabled-card"
                    }
                  ></div>
                )}
                <NavLink
                  to={`/product-details/${
                    activeShoppingTab === "rbvPack" ? "rbvPack" : "repurchase"
                  }/${product.id}`}
                >
                  <div className="product_box_image">
                    <img
                      src={product.image ?? "/images/product3.jpg"}
                      alt="product"
                    />
                  </div>
                </NavLink>
                <div className="product_box_content">
                  <div className="product_box_head">{product.name}</div>
                  <div className="product_box_category">{product.category}</div>
                  <div className="product_box_amnt">{`${
                    userSelectedCurrency.symbolLeft
                  } ${CurrencyConverter(
                    product.price,
                    conversionFactor
                  )}`}</div>
                </div>
                <div className="product_box_btn_sec">
                  {activeShoppingTab === "rbvPack" ? (
                    <button
                      id={`btn-${index}`}
                      className="product_box_btn1"
                      onClick={() => handleAddToCart(product.id)}
                      disabled={
                        !searchInputs.fullname || !searchInputs.username
                      }
                    >
                      {addCartMutation.isLoading && cartId === product.id && (
                        <div style={{ padding: "10px" }}>
                          <Loader
                            type="bubble-top"
                            bgColor={"white "}
                            size={30}
                          />
                        </div>
                      )}
                      <i className="fa fa-cart-shopping"></i> {t("add_to_cart")}
                    </button>
                  ) : (
                    <button
                      id={`btn-${index}`}
                      className="product_box_btn1"
                      onClick={() => handleAddToCart(product.id)}
                      disabled={
                        cartItems?.length > 0 ||
                        addCartMutation.isLoading ||
                        !searchInputs.fullname ||
                        !searchInputs.username
                      }
                    >
                      {addCartMutation.isLoading && cartId === product.id && (
                        <div style={{ padding: "10px" }}>
                          <Loader
                            type="bubble-top"
                            bgColor={"white "}
                            size={30}
                          />
                        </div>
                      )}
                      <i className="fa fa-cart-shopping"></i> {t("add_to_cart")}
                    </button>
                  )}
                  <NavLink
                    to={`/product-details/${
                      activeShoppingTab === "rbvPack" ? "rbvPack" : "repurchase"
                    }/${product.id}`}
                    className="product_box_btn2"
                  >
                    <i className="fa fa-eye"></i> {t("more_details")}
                  </NavLink>
                </div>
              </div>
            </div>
          ))
        ) : (
          // placeholder image
          <div className="newsMainBg">
            <img src="images/no-data-image1.jpg" alt="" />
            <div>{t("sorry_no_data_found")}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductLists;
